import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { ProductCard } from "@/components/ProductCard";
import { SectionHeading } from "@/pages/home/SectionHeading";

const container = { hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.06 } } };

export const BestsellersSection = ({ title, products, onViewAll }) => (
  <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-14">
    <SectionHeading>{title}</SectionHeading>
    {products.length === 0 ? (
      <p className="text-center text-sm text-muted-foreground py-10">No pieces in this category yet.</p>
    ) : (
      <motion.div variants={container} initial="hidden" animate="show" className="grid grid-cols-2 gap-x-5 gap-y-8 sm:gap-x-8 sm:gap-y-10">
        {products.slice(0, 4).map((p) => <ProductCard key={p.id} product={p} />)}
      </motion.div>
    )}
    <div className="text-center mt-10">
      <button
        data-testid="home-view-all-bestsellers"
        onClick={onViewAll}
        className="inline-flex items-center gap-1.5 px-6 py-2.5 rounded-full bg-card text-sm text-foreground card-shadow-soft hover:text-[hsl(var(--primary))] transition-colors duration-200"
      >
        View All <ArrowRight className="h-4 w-4" />
      </button>
    </div>
  </section>
);
